import ProfilePic from '../../assets/iconos/usuario.png'
import Eactive from '../../assets/iconos/estrella.verde.svg'
import Eoff from '../../assets/iconos/estrella.vacia.svg'
import dots from '../../assets/iconos/3dots.svg'
import smileEmoji from '../../assets/iconos/smile-emoji.svg'
import send from '../../assets/iconos/send.svg'

export default function ChatView ({user}){

    return(
        <div className="container-chat">
                <div  className='chat-card'> 
                       <div className='chat-picture setpointer'>
                        <a to={`/${user.id}`} >
                            <img src={user.profilePic} alt="contact-picture" className='chat-pic'/>
                        </a>
                        </div>
                        <div className='contact-info'>
                            <div className='contact-chart'>
                                <div className='contact-name'>
                                    <h4>{user.name+" " + user.lastname}</h4>
                                    <img src={Eactive} alt="favstar" className='favicon setpointer'/>
                                </div>
                                <div className='contact-settings setpointer'>
                                    <img src={dots} alt="3dots" className='favicon'/>
                                </div>
                            </div>
                            
                            <div className='last-message'>
                                <p>Conectado</p>
                            </div>
                        </div>     
                </div>

                <div className="chat-content">
                        <div className="chat-date">
                                <h6>30 de marzo</h6>
                        </div>

                </div>
                
                <div className="chat-section">
                    <div className="chat-input">
                            <textarea className='textarea-chat'/>
                            <div className='chat-options'>
                                <img src={send} alt="sendicon" className='favicon sethover setpointer'/>
                                <img src={smileEmoji} alt="smile emoji" className='favicon sethover setpointer'/>
                            </div>
                    </div>
                </div>
                
        </div>
    );
}